import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  demographics: "",  // Stores selected demographic labels
  promptInput: "",        // Stores the generated prompt text
  settings: {},
  selectedModel: "openai",
  promptHeader: "",
  programId: "",
  selectedPrompt: null,
  selectedProgram: null,
  loading: false,
  error: null,
  data: null,

  name:null,
  age:null,
  gender:null,
  callemotion:null,

  soapnotes:null,
  sessionguidance:null,
  caregoal:null,//pending
  patientTraits:null,
  notes : null,//pending

};

const playgroundSlice = createSlice({
  name: "playground",
  initialState,
  reducers: {
    setData: (state, action) => {
      console.log("Data:", action.payload);
      state.data = action.payload;
      if (action.payload.demographic) {
        state.demographics = action.payload.demographic.split(","); 
      }
    },
    setDemographics: (state, action) => {
      console.log("setDemographics Action Dispatched:", action.payload);
      state.demographics = action.payload.join(",");
    },
    setSelectedModelName: (state, action) => {
      console.log("Selected Model Updated:", action.payload);
      state.selectedModel = action.payload;  // ✅ Persist model selection
    },
    addDemographic: (state, action) => {
      if (!state.demographics.includes(action.payload)) {
        state.demographics = state.demographics ? `${state.demographics},${action.payload}` : action.payload;
        console.log("Added Demographic:", action.payload);
        console.log("Updated Demographics State:", state.demographics);
      }
    },
    removeDemographic: (state, action) => {

      const updatedDemographics = state.demographics.split(",").filter((item) => item !== action.payload).join(",")
      state.demographics = updatedDemographics;

    },
    setPromptInput: (state, action) => {
      console.log("setPromptInput Action Dispatched:", action.payload);
      state.promptInput = action.payload;
    },
    setSettings: (state, action) => {
      console.log("setSettings Action Dispatched:", action.payload);
      state.settings = {
        ...state.settings,
        ...action.payload  // Ensuring settings merge properly
      };
      console.log("Updated Settings State:", state.settings);
    },
    setPromptHeader: (state, action) => {
      console.log("Updated Prompt Header:", action.payload);
      state.promptHeader = action.payload;
    },
    setProgramId: (state, action) => {
      console.log("Updated Program ID:", action.payload);
      state.programId = action.payload;
    },
    setSelectedPrompt: (state, action) => {
      console.log("Selected Prompt:", action.payload);
      state.selectedPrompt = action.payload;
    },
    setSelectedProgram: (state, action) => {
      console.log("Selected Program:", action.payload);
      state.selectedProgram = action.payload;
    },
    setName: (state, action) => {
      console.log("Updated Name:", action.payload);
      state.name = action.payload;
    },
    setAge: (state, action) => {
      console.log("Updated Age:", action.payload);
      state.age = action.payload;
    },
    setGender: (state, action) => {
      console.log("Updated Gender:", action.payload);
      state.gender = action.payload;
    },
    setCallEmotion: (state, action) => {
      console.log("Updated Call Emotion:", action.payload);
      state.callemotion = action.payload;
    },
    setSoapNotes: (state, action) => {
      console.log("Updated SOAP Notes:", action.payload);
      state.soapnotes = action.payload;
    },
    setSessionGuidance: (state, action) => {
      console.log("Updated Session Guidance:", action.payload);
      state.sessionguidance = action.payload;
    },
    setCareGoal: (state, action) => {
      console.log("Updated Care Goal:", action.payload);
      state.caregoal = action.payload;
    },
    setPatientTraits: (state, action) => {
      console.log("Updated Patient Traits:", action.payload);
      state.patientTraits = action.payload;
    },
    setNotes: (state, action) => {
      console.log("Updated Notes:", action.payload);
      state.notes = action.payload;
    },
    setLoading: (state, action) => {
      console.log("Loading:", action.payload);
      state.loading = action.payload;
    },
    clearPlaygroundData: (state) => {
      console.log("Clearing Playground Data");
      state.demographics = [];
      state.promptInput = "";
      state.settings = {
        settingModalName: "",
        settingTemperature: "",
        settingTopk: "",
        settingTopp: "",
      };
      state.promptHeader = "";
      state.programId = "";
      state.selectedPrompt = null;
      state.selectedProgram = null;
    },
  },
});


export const {
  setData,
  setSelectedModelName,
  setDemographics,
  addDemographic,
  removeDemographic,
  setPromptInput,
  setSettings,
  setPromptHeader,
  setProgramId,
  setSelectedPrompt,
  setSelectedProgram,
  setName,
  setAge,
  setGender,
  setCallEmotion,
  setSoapNotes,
  setSessionGuidance,
  setCareGoal,
  setPatientTraits,
  setNotes,
  setLoading,
  clearPlaygroundData,
} = playgroundSlice.actions;

export default playgroundSlice.reducer;
